import { memo } from 'react';
import { Unplug, ArrowRight } from 'lucide-react';

interface EmptyDevicesListProps {
  onAddDevice: () => void;
}

export const EmptyDevicesList = memo(({ onAddDevice }: EmptyDevicesListProps) => (
  <div className="flex flex-col items-center py-10 text-center text-[var(--anl-text-muted)]">
    <Unplug className="mb-2 h-10 w-10 opacity-50" aria-hidden="true" />
    <div>No devices connected</div>
    <button
      onClick={onAddDevice}
      className="mt-4 flex items-center text-white/85 hover:text-white"
      aria-label="Add a device"
    >
      Add a device <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" />
    </button>
  </div>
));

EmptyDevicesList.displayName = 'EmptyDevicesList';
